enum MerchantType {
  RETAILER = 'RETAILER',
  CHAIN = 'CHAIN',
}

export default MerchantType;
